export const pageMetadata = {
  home: {
    title: "Global Payroll Migration - UK Payroll Migration Specialists",
    description: "Independent Payroll Migration Specialist | Client-Side | Vendor-Neutral | Compliance-Ready",
    keywords: "payroll migration, UK payroll services, global payroll migration, enterprise payroll, SME payroll",
    canonicalPath: "/",
    type: "website",
    schema: "WebSite",
    image: "/images/hero-business-team.jpg"
  },
  about: {
    title: "About Us - Global Payroll Migration Experts | UK-Based Team",
    description: "Meet our expert team of payroll migration specialists. Over 15 years of experience in seamless global payroll transitions with zero downtime.",
    keywords: "about global payroll migration, payroll experts, UK payroll team, migration specialists",
    canonicalPath: "/about",
    type: "website",
    schema: "AboutPage",
    image: "/images/about-hero-2.jpg"
  },
  contact: {
    title: "Contact Global Payroll Migration - Free Consultation | UK Specialists",
    description: "Get your free payroll migration consultation. Contact our UK-based experts for seamless payroll transitions with guaranteed compliance.",
    keywords: "contact payroll migration, free consultation, UK payroll experts, payroll migration quote",
    canonicalPath: "/contact",
    type: "website",
    schema: "ContactPage",
    image: "/images/contact-hero-2.jpg"
  },
  services: {
    sme: {
      title: "SME Payroll Migration Services - Small & Medium Enterprise Solutions",
      description: "Specialized payroll migration services for SMEs. Cost-effective solutions with personalized support and guaranteed compliance.",
      keywords: "SME payroll migration, small business payroll, medium enterprise payroll, affordable payroll migration",
      canonicalPath: "/services/sme",
      type: "service",
      schema: "Service",
      image: "/images/section-sme-2.jpg"
    },
    largeEnterprise: {
      title: "Large Enterprise Payroll Migration - Fortune 500 Trusted Solutions",
      description: "Enterprise-grade payroll migration services trusted by Fortune 500 companies. Complex multi-country migrations with zero downtime guarantee.",
      keywords: "enterprise payroll migration, Fortune 500 payroll, large company payroll, multi-country payroll",
      canonicalPath: "/services/large-enterprise",
      type: "service",
      schema: "Service",
      image: "/images/hero-enterprise-2.jpg"
    },
    consultancy: {
      title: "Payroll Migration Consultancy - Expert Advisory Services",
      description: "Strategic payroll migration consulting. Expert guidance for complex migrations, compliance audits, and payroll optimization.",
      keywords: "payroll consultancy, payroll advisory, migration consulting, payroll optimization",
      canonicalPath: "/services/consultancy",
      type: "service",
      schema: "Service",
      image: "/images/hero-consultancy-2.jpg"
    }
  },
  successStories: {
    sme: {
      title: "SME Success Stories - Small Business Payroll Migration Cases",
      description: "Real success stories from SME payroll migrations. See how we helped small and medium businesses achieve seamless transitions.",
      keywords: "SME success stories, small business payroll cases, payroll migration examples",
      canonicalPath: "/success-stories/sme",
      type: "website",
      schema: "CollectionPage",
      image: "/images/section-success-2.jpg"
    },
    largeEnterprise: {
      title: "Enterprise Success Stories - Fortune 500 Payroll Migration Cases",
      description: "Discover how we helped Fortune 500 companies achieve complex payroll migrations with zero downtime and full compliance.",
      keywords: "enterprise success stories, Fortune 500 cases, large company payroll migration",
      canonicalPath: "/success-stories/large-enterprise",
      type: "website",
      schema: "CollectionPage",
      image: "/images/hero-enterprise-2.jpg"
    },
    consultancy: {
      title: "Consultancy Success Stories - Strategic Payroll Migration Cases",
      description: "Strategic consulting success stories. Complex payroll transformations and optimization projects delivered with expert guidance.",
      keywords: "consultancy success stories, payroll consulting cases, strategic migration",
      canonicalPath: "/success-stories/consultancy",
      type: "website",
      schema: "CollectionPage",
      image: "/images/hero-consultancy-2.jpg"
    }
  },
  blog: {
    title: "Payroll Migration Blog - Expert Insights & Industry Updates",
    description: "Latest insights on payroll migration, compliance updates, and industry best practices from our expert team.",
    keywords: "payroll migration blog, payroll insights, compliance updates, migration best practices",
    canonicalPath: "/blog",
    type: "website",
    schema: "Blog",
    image: "/images/og-default.jpg"
  },
  quote: {
    title: "Get Free Payroll Migration Quote - Instant Estimate Calculator",
    description: "Get your free, no-obligation payroll migration quote. Instant estimate calculator with transparent pricing and expert consultation.",
    keywords: "payroll migration quote, free estimate, migration cost calculator, payroll pricing",
    canonicalPath: "/quote",
    type: "website",
    schema: "WebPage",
    image: "/images/og-default.jpg"
  },
  faq: {
    title: "Payroll Migration FAQ - Common Questions Answered",
    description: "Frequently asked questions about payroll migration. Get answers to common concerns about timing, costs, and compliance.",
    keywords: "payroll migration FAQ, migration questions, payroll answers, common concerns",
    canonicalPath: "/faq",
    type: "website",
    schema: "FAQPage",
    image: "/images/og-default.jpg"
  }
};
